//live Check-in-overview
export const LIVE_CHECK_IN_OVERVIEW_REQUEST = 'LIVE_CHECK_IN_OVERVIEW_REQUEST';
export const LIVE_CHECK_IN_OVERVIEW_SUCCESS = 'LIVE_CHECK_IN_OVERVIEW_SUCCESS';
export const LIVE_CHECK_IN_OVERVIEW_FAILURE = 'LIVE_CHECK_IN_OVERVIEW_FAILURE';

// live check in seater availability
export const LIVE_CHECK_IN_SEATER_AVAILABILITY_REQUEST = 'LIVE_CHECK_IN_SEATER_AVAILABILITY_REQUEST';
export const LIVE_CHECK_IN_SEATER_AVAILABILITY_SUCCESS = 'LIVE_CHECK_IN_SEATER_AVAILABILITY_SUCCESS';
export const LIVE_CHECK_IN_SEATER_AVAILABILITY_FAILURE = 'LIVE_CHECK_IN_SEATER_AVAILABILITY_FAILURE';

//live check in guest count
export const LIVE_CHECK_IN_GUEST_COUNT_REQUEST = 'LIVE_CHECK_IN_GUEST_COUNT_REQUEST';
export const LIVE_CHECK_IN_GUEST_COUNT_SUCCESS = 'LIVE_CHECK_IN_GUEST_COUNT_SUCCESS';
export const LIVE_CHECK_IN_GUEST_COUNT_FAILURE = 'LIVE_CHECK_IN_GUEST_COUNT_FAILURE';

//Live check in status
export const LIVE_CHECK_IN_STATUS_REQUEST = 'LIVE_CHECK_IN_STATUS_REQUEST';
export const LIVE_CHECK_IN_STATUS_SUCCESS = 'LIVE_CHECK_IN_STATUS_SUCCESS';
export const LIVE_CHECK_IN_STATUS_FAILURE = 'LIVE_CHECK_IN_STATUS_FAILURE'; 

//Live check in avg wait time
export const LIVE_CHECK_IN_AVG_WAIT_TIME_REQUEST = 'LIVE_CHECK_IN_AVG_WAIT_TIME_REQUEST';
export const LIVE_CHECK_IN_AVG_WAIT_TIME_SUCCESS = 'LIVE_CHECK_IN_AVG_WAIT_TIME_SUCCESS';
export const LIVE_CHECK_IN_AVG_WAIT_TIME_FAILURE = 'LIVE_CHECK_IN_AVG_WAIT_TIME_FAILURE';

//Live check in group avg wait time
export const LIVE_CHECK_IN_GROUP_AVG_WAIT_TIME_REQUEST = 'LIVE_CHECK_IN_GROUP_AVG_WAIT_TIME_REQUEST';
export const LIVE_CHECK_IN_GROUP_AVG_WAIT_TIME_SUCCESS = 'LIVE_CHECK_IN_GROUP_AVG_WAIT_TIME_SUCCESS';
export const LIVE_CHECK_IN_GROUP_AVG_WAIT_TIME_FAILURE = 'LIVE_CHECK_IN_GROUP_AVG_WAIT_TIME_FAILURE';

//live check in table
export const LIVE_CHECK_IN_TABLE_REQUEST = 'LIVE_CHECK_IN_TABLE_REQUEST';
export const LIVE_CHECK_IN_TABLE_SUCCESS = 'LIVE_CHECK_IN_TABLE_SUCCESS';
export const LIVE_CHECK_IN_TABLE_FAILURE = 'LIVE_CHECK_IN_TABLE_FAILURE';

//live check -in today
export const LIVE_CHECK_IN_TODAY_REQUEST = 'LIVE_CHECK_IN_TODAY_REQUEST';
export const LIVE_CHECK_IN_TODAY_SUCCESS = 'LIVE_CHECK_IN_TODAY_SUCCESS';
export const LIVE_CHECK_IN_TODAY_FAILURE = 'LIVE_CHECK_IN_TODAY_FAILURE';

//check-in overview
export const CHECK_IN_OVERVIEW_REQUEST = 'CHECK_IN_OVERVIEW_REQUEST';
export const CHECK_IN_OVERVIEW_SUCCESS = 'CHECK_IN_OVERVIEW_SUCCESS';
export const CHECK_IN_OVERVIEW_FAILURE = 'CHECK_IN_OVERVIEW_FAILURE';

//check-in overview hourly
export const CHECK_IN_OVERVIEW_HOURLY_REQUEST = 'CHECK_IN_OVERVIEW_HOURLY_REQUEST';
export const CHECK_IN_OVERVIEW_HOURLY_SUCCESS = 'CHECK_IN_OVERVIEW_HOURLY_SUCCESS';
export const CHECK_IN_OVERVIEW_HOURLY_FAILURE = 'CHECK_IN_OVERVIEW_HOURLY_FAILURE';

// check-in overview guests hourly
export const CHECK_IN_OVERVIEW_GUESTS_HOURLY_REQUEST = 'CHECK_IN_OVERVIEW_GUESTS_HOURLY_REQUEST';
export const CHECK_IN_OVERVIEW_GUESTS_HOURLY_SUCCESS = 'CHECK_IN_OVERVIEW_GUESTS_HOURLY_SUCCESS';
export const CHECK_IN_OVERVIEW_GUESTS_HOURLY_FAILURE = 'CHECK_IN_OVERVIEW_GUESTS_HOURLY_FAILURE';


//check-in overview daily and guest
export const CHECK_IN_OVERVIEW_DAILY_AND_GUEST_REQUEST = 'CHECK_IN_OVERVIEW_DAILY_AND_GUEST_REQUEST';
export const CHECK_IN_OVERVIEW_DAILY_AND_GUEST_SUCCESS = 'CHECK_IN_OVERVIEW_DAILY_AND_GUEST_SUCCESS';
export const CHECK_IN_OVERVIEW_DAILY_AND_GUEST_FAILURE = 'CHECK_IN_OVERVIEW_DAILY_AND_GUEST_FAILURE';

// check in overview dine-in group
export const CHECK_IN_OVERVIEW_DINE_IN_GROUP_REQUEST = 'CHECK_IN_OVERVIEW_DINE_IN_GROUP_REQUEST';
export const CHECK_IN_OVERVIEW_DINE_IN_GROUP_SUCCESS = 'CHECK_IN_OVERVIEW_DINE_IN_GROUP_SUCCESS';
export const CHECK_IN_OVERVIEW_DINE_IN_GROUP_FAILURE = 'CHECK_IN_OVERVIEW_DINE_IN_GROUP_FAILURE';

//check-in overview guest size
export const CHECK_IN_OVERVIEW_GUEST_SIZE_REQUEST = 'CHECK_IN_OVERVIEW_GUEST_SIZE_REQUEST';
export const CHECK_IN_OVERVIEW_GUEST_SIZE_SUCCESS = 'CHECK_IN_OVERVIEW_GUEST_SIZE_SUCCESS';
export const CHECK_IN_OVERVIEW_GUEST_SIZE_FAILURE = 'CHECK_IN_OVERVIEW_GUEST_SIZE_FAILURE';


//check-in overview table details
export const CHECK_IN_OVERVIEW_TABLE_DETAILS_REQUEST = 'CHECK_IN_OVERVIEW_TABLE_DETAILS_REQUEST';
export const CHECK_IN_OVERVIEW_TABLE_DETAILS_SUCCESS = 'CHECK_IN_OVERVIEW_TABLE_DETAILS_SUCCESS';
export const CHECK_IN_OVERVIEW_TABLE_DETAILS_FAILURE = 'CHECK_IN_OVERVIEW_TABLE_DETAILS_FAILURE';

//check-in overview top customer
export const CHECK_IN_OVERVIEW_TOP_CUSTOMER_REQUEST = 'CHECK_IN_OVERVIEW_TOP_CUSTOMER_REQUEST';
export const CHECK_IN_OVERVIEW_TOP_CUSTOMER_SUCCESS = 'CHECK_IN_OVERVIEW_TOP_CUSTOMER_SUCCESS';
export const CHECK_IN_OVERVIEW_TOP_CUSTOMER_FAILURE = 'CHECK_IN_OVERVIEW_TOP_CUSTOMER_FAILURE';

//check-in overview avg wait time group
export const CHECK_IN_OVERVIEW_AVG_WAIT_TIME_GROUP_REQUEST = 'CHECK_IN_OVERVIEW_AVG_WAIT_TIME_GROUP_REQUEST';
export const CHECK_IN_OVERVIEW_AVG_WAIT_TIME_GROUP_SUCCESS = 'CHECK_IN_OVERVIEW_AVG_WAIT_TIME_GROUP_SUCCESS';
export const CHECK_IN_OVERVIEW_AVG_WAIT_TIME_GROUP_FAILURE = 'CHECK_IN_OVERVIEW_AVG_WAIT_TIME_GROUP_FAILURE';

